import script from "./ReferenteEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenteEditorView.vue?vue&type=script&setup=true&lang=js"

import "./ReferenteEditorView.vue?vue&type=style&index=0&id=6b455870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b455870"]])

export default __exports__